// extracted by mini-css-extract-plugin
export default {"TitleDialogContent":"ModalEstado_TitleDialogContent__YSyoa","TitleDialogTexto":"ModalEstado_TitleDialogTexto__ZIfbH"};